import React from 'react';

import { DownloadIconProps } from '../../types';

const DownloadIcon: React.FC<DownloadIconProps> = ({
  width = 20,
  height = 20,
  color = '#000000',
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 13L6 9H8V3H12V9H14L10 13Z" fill={color} />
      <path d="M4 15H16V17H4V15Z" fill={color} />
    </svg>
  );
};

export default DownloadIcon;
